/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-row[_ngcontent-%COMP%]{-webkit-box-align:center;align-items:center;position:relative}"];
export { styles as styles };
